export default class Auth {
  static doLogin() {
    window.location.href = process.env.VUE_APP_AUTH_SERVER + '?redir=' + encodeURIComponent(window.location.href);
  }
}
